module.exports = __webpack_public_path__ + "static/media/ss-sample-of-certificate-5mm.28f690b3.jpg";